export const MEETING_POINT_KEYS = [
  "meeting_point_name",
  "meeting_point_address_line_1",
  "meeting_point_address_line_2",
  "meeting_point_city_id",
  "meeting_point_postal_code",
  "meeting_point_state",
  "meeting_point_instructions",
  "meeting_point_lat",
  "meeting_point_long",
  "meeting_point_final",
];

export const MEETING_POINT_INSTRUCTION_KEY = "meeting_point_instructions";
